import { PortalBaseUrl } from '@ibkr/clientportal.common/src/js/portalBaseUrl.js'

if (window.ibrtDefaultSubscriptions == null) {
    window.ibrtDefaultSubscriptions = [];
}

/**
 * get an instance with realtime.instance()
 * subscribe with rt.subscribe('topic', 'type', {
 *  onSubscribed: () => console.debug('onSubscribed', 'topic'),
 *  onMessage: (e) => console.debug('onMessage', e),
 *  onError:   (e) => console.debug('onError', e),
 * });
 */

const debug = process.env.DEBUG_REALTIME || false;

const PING = 'ech+hb';

const decoder = 'TextDecoder' in window ? new TextDecoder() : {
    decode: data => {
        const aBytes = new Uint8Array(data);
        let sView = '';
        for (let nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(
                nPart > 251 && nPart < 254 && nIdx + 5 < nLen ?
                    (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ?
                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ?
                    (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ?
                    (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ?
                    (nPart - 192 << 6) + aBytes[++nIdx] - 128
                : nPart);
        }
        return sView;
    }
};


export default class Realtime {

    // private; use realtime.instance()
    constructor() {
        this.hid = 1;
        this.subscriptions = window.ibrtDefaultSubscriptions;
        this.log = false;
        this.tickle = undefined;
        if (process.env.WS_BASE_URL) {
            this.wsUrl = process.env.WS_BASE_URL;
        } else {
            this.wsUrl = (location.protocol == 'https:' ? 'wss:' : 'ws:') + '//' + location.host + PortalBaseUrl.get() + '/ws';
        }
        //console.log("this.wsUrl Before", this.wsUrl)
        //this.wsUrl =  "ws://ny5qa1:63100/v1/mkt/ws";
        //console.log("this.wsUrl", this.wsUrl)
    }

    addEventListener(cb) {
        this.listener = cb;
    }

    supportsWs() {
        return 'WebSocket' in window;
    }

    connect() {
        console.debug('connecting to ws: ', this.wsUrl);
        if (!this.supportsWs()) {
            console.error('ws not supported');
            return;
        }

        const ws = new WebSocket(this.wsUrl);
        ws.binaryType = 'arraybuffer';
        ws.onopen = this.onOpen.bind(this);
        ws.onerror = this.onError.bind(this);
        ws.onclose = this.onClose.bind(this);
        ws.onmessage = this.onMessage.bind(this);
        this.connected = false;
        this.ws = ws;
    }

    disconnect() {
        this.ws && this.ws.close();
    }

    onOpen(e) {
        console.debug('Websocket connection opened.');
        this.connected = true;
        if (!this.tickle) { //tickle websocket every 20s
            this.tickle = setInterval(() => this.send(PING), 20000);
        }
        this.listener && this.listener({ event: 'open', payload: e});
    }

    onError(e) {
        console.error('error', e)
        this.listener && this.listener({ event: 'error', payload: e});
    }

    onClose(e) {
        console.debug('Websocket connection closed.', e);
        this.connected = false;
        if (this.tickle) {
            clearInterval(this.tickle);
        }
        this.listener && this.listener({ event: 'close', payload: e});
    }

    /**
     * A subscription has a TOPIC.
     *
     * A TOPIC can have multiple handlers.
     *
     * Each handler has different channels, onError, onMessage, onSubscribed.
     */
    onMessage(e) {
        const msg = decoder.decode(e.data);
        this.log && console.debug('<- on message', msg)
        if (msg === PING) {
            this.log && console.debug('echo hb back');
            return;
        }
        const json = JSON.parse(msg);
        const topic = json.topic || '';
        if (!topic) {
            console.debug('no topic', json);
            return;
        }
        const subs = this.subscriptions.filter(s => s.topic == topic);
        this.log && console.debug(`Topic: ${topic}\nData: ${JSON.stringify(json)}\nSubscriber Count: ${subs.length}`);
        if (subs.length == 0) {
            if (topic != 'system') {
                this.log && console.warn('no subscribers for ', topic, json);
                //this.cancelAll(topic);
            }
            return;
        }
        subs.forEach(s => {
            if (json.success) {
                s.handlers.forEach(h => h.onSubscribed(json));
            } else {
                s.handlers.forEach(h => h.onMessage(json));
            }
        });
    }

    send(str) {
        this.log && console.debug('-> sending ', str);
        this.ws && this.ws.send(str);
    }

    _registerSubscription(topic, type, args, handler) {
        const subscription = this.subscriptions.find(s => {
            if (args?.requestId) {
                return s.topic == topic && args?.requestId == s.args?.requestId;
            } else {
                return s.topic == topic;
            }
        });
        if (subscription) {
            subscription.handlers.push(handler);
        } else {
            this.subscriptions.push({
                topic: topic,
                type: type,
                args: args,
                handlers: [ handler ]
            })
        }
        if (this.ws.readyState == this.ws.OPEN) {
            let params = topic;
            if (args) {
                params += '+' + JSON.stringify(args);
            }
            this.send(params);
        } else {
            console.error('subscription queued, websocket not ready');
        }
    }

    cancelId(topic, handlerId, onConfirm) {
        debug && console.debug('cancel ', topic, 'handler', handlerId);
        if (handlerId) {
            const sub = this.subscriptions.find(s => s.topic == 'u+'+topic);
            if (sub) {
                const idx = sub.handler.findIndex(h => h.id == handlerId);
                if (idx != -1) {
                    sub.handler.slice(idx, 1);
                }
                if (sub.handler.length > 0) {
                    debug && console.debug('subscriptions left', sub.handler.length);
                }
                return;
            }
        }

        // no subscription left; inform server and update list
        this.subscriptions = this.subscriptions.filter(s => s.topic != topic);
        this.send(topic);

        if ($build.mode == 'development') { // important to know if there are any lingering subscriptions
            debug && console.debug('subscriptions left', this.subscriptions.length)
        }
    }

    newCancelSubscriptions(topic, args) {
        this.log && console.debug('new cancel subscription ', topic, 'args', args);
        this.subscriptions = this.subscriptions.filter(s => {
            if (s.topic == topic) {
                if (args?.requestId) {
                    return args?.requestId != s?.args?.requestId;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        });
    }

    cancelAll(topic, onConfirm) { // todo: onConfirm
        this.cancelId(topic, null, onConfirm);
    }

    isSubscribed(topic) {
        return this.subscriptions.find(s => s.topic == topic) != undefined;
    }

    /**
     * If the subscription exists it just forwards the payload. Otherwise it subscribes with subscribeArgs.
     */
    subscribeOrSendArgs(topic, type, payload, args) {
        const subscription = this.subscriptions.find(s => s.topic == topic);
        if (subscription) {
            this.send(topic + '+' + JSON.stringify(payload));
        } else {
            return this.subscribeArgs(topic, type, payload, args);
        }
    }

    subscribeArgs(topic, type, args, { onSubscribed, onMessage, onError } ) {
        this.log && console.debug('realtime subscribe args', topic, 'args', args);
        if (!this.supportsWs()) {
            onError('ws not supported');
            return;
        }

        if (onMessage == null) {
            throw Error('onMessage handler to subscription expected');
        }
        const handler = {
                id: this.hid++,
                onSubscribed: onSubscribed ? onSubscribed : () => debug && console.debug('subscribed ' + topic),
                onMessage: onMessage,
                onError: onError ? onError : () => console.error('subscription error ' + topic)
        }
        this._registerSubscription(topic, type, args, handler);
        return handler.id;
    }

    subscribe(topic, type, cbs) {
        this.subscribeArgs(topic, type, null, cbs);
    }

    toggleConsoleLog() {
        this.log = !this.log;
    }

    resubscribe() {
        const subscriptions = [ ...this.subscriptions ];
        for (let i = 0; i < subscriptions.length; i++) {
            const subscription = subscriptions[i];
            this.cancelAll(subscription.topic);
        }
        this.subscriptions = [];
        for (let i = 0; i < subscriptions.length; i++) {
            const subscription = subscriptions[i];
            for (let j = 0; j < subscription.handlers.length; j++) {
                this._registerSubscription(subscription.topic, subscription.type, subscription.args, subscription.handlers[j]);
            }
        }
    }

    clearSubscriptions(type) {
        if (!type) {
            console.error('Couldnt clear realtime subscriptions: type missing.');
            return;
        }
        this.subscriptions = this.subscriptions.filter(s => s.type !== type);
    }

    /**
     * Backend can send some unsolicited messages. Handlers for such messages can be set
     * using following method
     */
    static setUnsolicitedHandlers(subscribers) {
        if (!subscribers) {
            return;
        }
        window.ibrtDefaultSubscriptions = subscribers;
    }

    static instance() {
        try {
            if (window.ibrt == null) {
                window.ibrt = new Realtime();
            }
            const rt = window.ibrt;
            if (!rt.connected) {
                rt.connect();
            }
            return rt;
        } catch (e) {
            console.error('realtime instance e', e);
        }
    }

}
